import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CommonModal = ({ open, onClose, title, children, onConfirm, confirmText = "OK", cancelText = "Close", showActions = true }) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-center",alignContent:"center",background:"rgba(0, 165, 162, 0.7)",color:"white" }}>
                {title}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon color="error"/>
                </IconButton>
            </DialogTitle>
            <DialogContent dividers className="text-center">
                {children}
            </DialogContent>
            {showActions && (
                <DialogActions>
                    <Button onClick={onClose} color="secondary">
                        {cancelText}
                    </Button>
                    {onConfirm && (
                        <Button onClick={onConfirm} color="primary" variant="contained">
                            {confirmText}
                        </Button>
                    )}
                </DialogActions>
            )}
        </Dialog>
    );
};

export default CommonModal;
